import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Net2BeepleMethodsEnum } from '../enums/net2beeple-methods.enum';
import { HttpService } from '../http/http.service';
import { RetrieveAddressByGoogleBody, RetrieveAddressByGoogleReply } from './location.types';

@Injectable({
    providedIn: 'root'
})
export class LocationService {

    constructor(
        private http: HttpService
    ) { }

    retrieveGoogleAddress(body: RetrieveAddressByGoogleBody) {
        return this.http.post<RetrieveAddressByGoogleReply>(Net2BeepleMethodsEnum.retrieveAddressByGoogle, body).pipe(
            map(reply => reply.address ?? [])
        );
    }

}
